/**
 * @group Constants

@summary
<blockquote>Available logging transport types</blockquote>

@example
```typescript
const transport = LOG_TRANSPORTS.CONSOLE;
```
 * @internal
 */
export const LOG_TRANSPORTS = {
    CONSOLE: 'console',
    SENTRY: 'sentry',
  } as const;